





















import { format } from 'date-fns'
import fromUnixTime from 'date-fns/fromUnixTime'
import { Icon } from '@alpha/ink'
import Redactor from '../Redactor.vue'
import { BackgroundTypeDefault } from './EditBackgroundModal.vue'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    Redactor,
    Icon
  }
})
export default class IntroDisplay extends Vue {
  @Prop({ required: true }) report!: any
  @Prop({ required: true }) editable!: boolean

  get date ():string {
    const time:Date = fromUnixTime(this.report.client.time)
    return format(time, 'MMM do, yyyy')
  }

  get backgroundStyle ():any {
    switch (this.report.background.type) {
      case BackgroundTypeDefault.IMAGE:
        return { 'background-image': `url('${this.report.background.imageURL}')` }
      case BackgroundTypeDefault.COLOR:
        // eslint-disable-next-line no-case-declarations
        const { r, g, b } = this.report.background.color
        return { 'background-color': `rgb(${r}, ${g}, ${b})` }
      default:
        console.error('background:', this.report.background)
        throw new Error('Missing background type')
    }
  }

  scrollNext () {
    this.$emit('scrollNext')
  }
}
